// extracted by mini-css-extract-plugin
export var container = "_sl-0";
export var inputWidth = "_sl-1";